/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CustomerType,
  GetSelectFieldProviders200,
  GetSelectFieldValuesParams,
  GroupedFieldConfigurationDTO,
  SelectFieldOption,
  SelectFieldProviderInfo
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const evictAllFieldConfigurationCaches = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/field-configuration/evict-all-caches`, method: 'POST', signal
    },
      options);
    }
  


export const getEvictAllFieldConfigurationCachesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evictAllFieldConfigurationCaches>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof evictAllFieldConfigurationCaches>>, TError,void, TContext> => {

const mutationKey = ['evictAllFieldConfigurationCaches'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evictAllFieldConfigurationCaches>>, void> = () => {
          

          return  evictAllFieldConfigurationCaches(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EvictAllFieldConfigurationCachesMutationResult = NonNullable<Awaited<ReturnType<typeof evictAllFieldConfigurationCaches>>>
    
    export type EvictAllFieldConfigurationCachesMutationError = unknown

    export const useEvictAllFieldConfigurationCaches = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evictAllFieldConfigurationCaches>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof evictAllFieldConfigurationCaches>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getEvictAllFieldConfigurationCachesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const resetFieldConfigurationToTemplate = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GroupedFieldConfigurationDTO>(
      {url: `/api/field-configuration/category/${categoryId}/reset-to-template`, method: 'POST', signal
    },
      options);
    }
  


export const getResetFieldConfigurationToTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetFieldConfigurationToTemplate>>, TError,{categoryId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetFieldConfigurationToTemplate>>, TError,{categoryId: number}, TContext> => {

const mutationKey = ['resetFieldConfigurationToTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetFieldConfigurationToTemplate>>, {categoryId: number}> = (props) => {
          const {categoryId} = props ?? {};

          return  resetFieldConfigurationToTemplate(categoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetFieldConfigurationToTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof resetFieldConfigurationToTemplate>>>
    
    export type ResetFieldConfigurationToTemplateMutationError = unknown

    export const useResetFieldConfigurationToTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetFieldConfigurationToTemplate>>, TError,{categoryId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetFieldConfigurationToTemplate>>,
        TError,
        {categoryId: number},
        TContext
      > => {

      const mutationOptions = getResetFieldConfigurationToTemplateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const evictFieldConfigurationCache = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/field-configuration/category/${categoryId}/evict-cache`, method: 'POST', signal
    },
      options);
    }
  


export const getEvictFieldConfigurationCacheMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evictFieldConfigurationCache>>, TError,{categoryId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof evictFieldConfigurationCache>>, TError,{categoryId: number}, TContext> => {

const mutationKey = ['evictFieldConfigurationCache'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evictFieldConfigurationCache>>, {categoryId: number}> = (props) => {
          const {categoryId} = props ?? {};

          return  evictFieldConfigurationCache(categoryId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EvictFieldConfigurationCacheMutationResult = NonNullable<Awaited<ReturnType<typeof evictFieldConfigurationCache>>>
    
    export type EvictFieldConfigurationCacheMutationError = unknown

    export const useEvictFieldConfigurationCache = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evictFieldConfigurationCache>>, TError,{categoryId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof evictFieldConfigurationCache>>,
        TError,
        {categoryId: number},
        TContext
      > => {

      const mutationOptions = getEvictFieldConfigurationCacheMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getSelectFieldValues = (
    providerName: string,
    params?: GetSelectFieldValuesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SelectFieldOption[]>(
      {url: `/api/field-configuration/select-field/${providerName}/values`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetSelectFieldValuesQueryKey = (providerName?: string,
    params?: GetSelectFieldValuesParams,) => {
    return [`/api/field-configuration/select-field/${providerName}/values`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSelectFieldValuesQueryOptions = <TData = Awaited<ReturnType<typeof getSelectFieldValues>>, TError = unknown>(providerName: string,
    params?: GetSelectFieldValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSelectFieldValuesQueryKey(providerName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSelectFieldValues>>> = ({ signal }) => getSelectFieldValues(providerName,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(providerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldValues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSelectFieldValuesQueryResult = NonNullable<Awaited<ReturnType<typeof getSelectFieldValues>>>
export type GetSelectFieldValuesQueryError = unknown


export function useGetSelectFieldValues<TData = Awaited<ReturnType<typeof getSelectFieldValues>>, TError = unknown>(
 providerName: string,
    params: undefined |  GetSelectFieldValuesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldValues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSelectFieldValues>>,
          TError,
          Awaited<ReturnType<typeof getSelectFieldValues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSelectFieldValues<TData = Awaited<ReturnType<typeof getSelectFieldValues>>, TError = unknown>(
 providerName: string,
    params?: GetSelectFieldValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldValues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSelectFieldValues>>,
          TError,
          Awaited<ReturnType<typeof getSelectFieldValues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSelectFieldValues<TData = Awaited<ReturnType<typeof getSelectFieldValues>>, TError = unknown>(
 providerName: string,
    params?: GetSelectFieldValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSelectFieldValues<TData = Awaited<ReturnType<typeof getSelectFieldValues>>, TError = unknown>(
 providerName: string,
    params?: GetSelectFieldValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSelectFieldValuesQueryOptions(providerName,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getProviderInfo = (
    providerName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SelectFieldProviderInfo>(
      {url: `/api/field-configuration/select-field/${providerName}/info`, method: 'GET', signal
    },
      options);
    }
  

export const getGetProviderInfoQueryKey = (providerName?: string,) => {
    return [`/api/field-configuration/select-field/${providerName}/info`] as const;
    }

    
export const getGetProviderInfoQueryOptions = <TData = Awaited<ReturnType<typeof getProviderInfo>>, TError = unknown>(providerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProviderInfoQueryKey(providerName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProviderInfo>>> = ({ signal }) => getProviderInfo(providerName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(providerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProviderInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProviderInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getProviderInfo>>>
export type GetProviderInfoQueryError = unknown


export function useGetProviderInfo<TData = Awaited<ReturnType<typeof getProviderInfo>>, TError = unknown>(
 providerName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviderInfo>>,
          TError,
          Awaited<ReturnType<typeof getProviderInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProviderInfo<TData = Awaited<ReturnType<typeof getProviderInfo>>, TError = unknown>(
 providerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviderInfo>>,
          TError,
          Awaited<ReturnType<typeof getProviderInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProviderInfo<TData = Awaited<ReturnType<typeof getProviderInfo>>, TError = unknown>(
 providerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetProviderInfo<TData = Awaited<ReturnType<typeof getProviderInfo>>, TError = unknown>(
 providerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderInfo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProviderInfoQueryOptions(providerName,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSelectFieldProviders = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSelectFieldProviders200>(
      {url: `/api/field-configuration/select-field/providers`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSelectFieldProvidersQueryKey = () => {
    return [`/api/field-configuration/select-field/providers`] as const;
    }

    
export const getGetSelectFieldProvidersQueryOptions = <TData = Awaited<ReturnType<typeof getSelectFieldProviders>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSelectFieldProvidersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSelectFieldProviders>>> = ({ signal }) => getSelectFieldProviders(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldProviders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSelectFieldProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof getSelectFieldProviders>>>
export type GetSelectFieldProvidersQueryError = unknown


export function useGetSelectFieldProviders<TData = Awaited<ReturnType<typeof getSelectFieldProviders>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldProviders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSelectFieldProviders>>,
          TError,
          Awaited<ReturnType<typeof getSelectFieldProviders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSelectFieldProviders<TData = Awaited<ReturnType<typeof getSelectFieldProviders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldProviders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSelectFieldProviders>>,
          TError,
          Awaited<ReturnType<typeof getSelectFieldProviders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSelectFieldProviders<TData = Awaited<ReturnType<typeof getSelectFieldProviders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSelectFieldProviders<TData = Awaited<ReturnType<typeof getSelectFieldProviders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectFieldProviders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSelectFieldProvidersQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGroupedFieldConfiguration = (
    customerType: CustomerType,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GroupedFieldConfigurationDTO>(
      {url: `/api/field-configuration/grouped-fields/${customerType}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetGroupedFieldConfigurationQueryKey = (customerType?: CustomerType,) => {
    return [`/api/field-configuration/grouped-fields/${customerType}`] as const;
    }

    
export const getGetGroupedFieldConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError = unknown>(customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupedFieldConfigurationQueryKey(customerType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupedFieldConfiguration>>> = ({ signal }) => getGroupedFieldConfiguration(customerType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGroupedFieldConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupedFieldConfiguration>>>
export type GetGroupedFieldConfigurationQueryError = unknown


export function useGetGroupedFieldConfiguration<TData = Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError = unknown>(
 customerType: CustomerType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupedFieldConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getGroupedFieldConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGroupedFieldConfiguration<TData = Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError = unknown>(
 customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupedFieldConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getGroupedFieldConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGroupedFieldConfiguration<TData = Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError = unknown>(
 customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGroupedFieldConfiguration<TData = Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError = unknown>(
 customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupedFieldConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGroupedFieldConfigurationQueryOptions(customerType,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFieldConfigurationForCategoryGrouped = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GroupedFieldConfigurationDTO>(
      {url: `/api/field-configuration/category/${categoryId}/configuration`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFieldConfigurationForCategoryGroupedQueryKey = (categoryId?: number,) => {
    return [`/api/field-configuration/category/${categoryId}/configuration`] as const;
    }

    
export const getGetFieldConfigurationForCategoryGroupedQueryOptions = <TData = Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFieldConfigurationForCategoryGroupedQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>> = ({ signal }) => getFieldConfigurationForCategoryGrouped(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFieldConfigurationForCategoryGroupedQueryResult = NonNullable<Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>>
export type GetFieldConfigurationForCategoryGroupedQueryError = unknown


export function useGetFieldConfigurationForCategoryGrouped<TData = Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>,
          TError,
          Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFieldConfigurationForCategoryGrouped<TData = Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>,
          TError,
          Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFieldConfigurationForCategoryGrouped<TData = Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFieldConfigurationForCategoryGrouped<TData = Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFieldConfigurationForCategoryGrouped>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFieldConfigurationForCategoryGroupedQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



